import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loading-screen',
  template: `
    <div class="loading-container">
      <div class="loading-content">
        <div class="brandmark"><img [src]="logoUrl" alt="Logo" class="brand-logo" appStaticSrc /></div>
        <div class="spinner"></div>
        <h2>Loading...</h2>
        <p>Please wait while we prepare your workspace</p>
      </div>
    </div>
  `,
  styles: [`
    :host {
      --brand: #E60000;
      --muted: #6B7280;
      --page: #F7F8FA;
    }

    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100vw;
      background: var(--page);
      font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Arial, sans-serif;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
    }

    .loading-content {
      text-align: center;
      color: #1A1A1A;
    }

    .brandmark {
      display: inline-flex;
      align-items: center;
      margin-bottom: 26px;
    }

    .brandmark .brand-logo {
      height: 84px;
      width: auto;
      display: block;
    }

    .spinner {
      border: 4px solid #F0D2D2;
      border-top: 4px solid var(--brand);
      border-radius: 50%;
      width: 52px;
      height: 52px;
      animation: spin 1s linear infinite;
      margin: 0 auto 22px;
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    h2 {
      margin: 0 0 6px;
      font-size: 20px;
      font-weight: 700;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: var(--muted);
    }
  `]
})
export class LoadingScreenComponent {
  logoUrl: string =
    environment.navbarLogoImageUrl || 'assets/images/zinger-logo.png';
}
